import { render, staticRenderFns } from "./ServicePage.vue?vue&type=template&id=2f293344&scoped=true"
import script from "./ServicePage.vue?vue&type=script&lang=js"
export * from "./ServicePage.vue?vue&type=script&lang=js"
import style0 from "./ServicePage.vue?vue&type=style&index=0&id=2f293344&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f293344",
  null
  
)

export default component.exports